import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListCheck } from '@fortawesome/pro-regular-svg-icons';
import { Grid, Text, Button } from '@morressier/ts';
import { logEvent } from 'utils/eventTracking';
import ProductCard from 'components/Cards/ProductCard';
import { ProductCardCTAWrapper } from 'components/Cards/ProductCard/styles';
import { useFeatureFlagContext } from 'context/FeatureFlagProvider';
import { FEATURE_FLAGS } from 'utils/constants';

const integrityChecksUrl =
  'https://www.morressier.com/products/automated-submission-checks?utm_campaign=E-commerce%20-%20Automated%20Submission%20Checks&utm_source=Platform%20Homepage';

interface Props {
  isEnterpriseUser: boolean;
  purchasedEventModules: string[];
}

const FeaturedProducts = (props: Props) => {
  const features = useFeatureFlagContext();

  const isIntegrityCheckEnabled =
    features[FEATURE_FLAGS.PRODUCT_CATALOG_INTEGRITY_CHECK];

  return (
    <>
      <Text
        size="h4_new"
        key="featured-products-text"
        fontWeight="bold"
        font="Orleans"
        style={{ marginBottom: '1rem', color: 'var(--color-mono-0)' }}
      >
        Maximize impact with our products
      </Text>
      <GridContainer xsmall={1} medium={2} xlarge={2}>
        <ProductCard
          bannerImage="https://res.cloudinary.com/morressier-gmbh/image/upload/v1679477235/home-client/peer-review-workflow.jpg"
          title={<>Submission Manager</>}
          description={
            <p>
              Collect, review, and publish all your submissions, regardless of
              the format, with easy-to-use research management tools.
            </p>
          }
          cta={
            <ProductCardCTAWrapper
              bkgColor="#1C41E4"
              foregroundColor="var(--color-mono-100)"
            >
              <Button
                as="a"
                round
                href="/contact/demo"
                target="_blank"
                onClick={() =>
                  logEvent('INTEREST_IN_SUB_MANAGER_FROM_HOME_CLIKED')
                }
              >
                Book a Demo
              </Button>
            </ProductCardCTAWrapper>
          }
        />
        <ProductCard
          bannerImage="https://res.cloudinary.com/morressier-gmbh/image/upload/v1679477236/home-client/integrity-check.jpg"
          title={<>Author Submission Checks</>}
          description={
            <p>
              Get your papers through the peer review process quicker and meet
              industry standards faster. Simply upload your paper and receive a
              thorough analysis of its compliance.
            </p>
          }
          cta={
            <ProductCardCTAWrapper
              bkgColor="#1C41E4"
              foregroundColor="var(--color-mono-100)"
            >
              {isIntegrityCheckEnabled ? (
                <Button
                  as="a"
                  round
                  iconLeft={<FontAwesomeIcon icon={faListCheck} />}
                  href={integrityChecksUrl}
                  target="_blank"
                  onClick={() => logEvent('INTEGRITY_CHECKS_TRIAL_CLICKED')}
                >
                  Check your Paper
                </Button>
              ) : (
                <Button disabled round>
                  Coming Soon
                </Button>
              )}
            </ProductCardCTAWrapper>
          }
        />
      </GridContainer>
    </>
  );
};

const GridContainer = styled(Grid)`
  gap: 2rem;
  @media (min-width: 960px) {
    gap: 1rem;
  }
  @media (min-width: 1024px) {
    gap: 2rem;
  }
`;

export default FeaturedProducts;
